import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/evo_classroom.png'


const _hoisted_1 = {
  key: 0,
  class: "mb-12 card bg-light"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {"height":"50px"},
    class: "mx-auto mb-8"
  })
], -1)
const _hoisted_3 = { class: "text-lg mb-4" }
const _hoisted_4 = { class: "ml-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons text-success" }, "check_circle", -1)
const _hoisted_6 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_7 = {
  key: 0,
  class: "mt-12 flex flex-col space-y-4"
}
const _hoisted_8 = { class: "flex flex-col items-center mb-4 mt-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"height":"40px"}
}, null, -1)
const _hoisted_10 = { class: "font-normal mt-2" }
const _hoisted_11 = { class: "mt-8 flex items-center space-x-2 banner banner-light" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text-yellow-400 material-icons-outlined" }, " lightbulb ", -1)
const _hoisted_13 = { class: "mb-2" }
const _hoisted_14 = { class: "banner banner-danger my-4" }
const _hoisted_15 = { class: "flex space-x-1 items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " error_outline ", -1)
const _hoisted_17 = { class: "flex flex-col space-y-2" }
const _hoisted_18 = {
  key: 1,
  class: ""
}
const _hoisted_19 = {
  key: 0,
  class: "flex flex-col items-center mt-2 mb-auto"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "mb-4 opacity-50 material-icons-outlined",
  style: {"font-size":"5rem"}
}, "error_outline", -1)
const _hoisted_21 = { class: "mb-4 select-none opacity-70" }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "grid md:grid-cols-3 2xl:grid-cols-4 gap-4 mt-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GoogleScopeChecker = _resolveComponent("GoogleScopeChecker")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_GoogleClassroomCourseItem = _resolveComponent("GoogleClassroomCourseItem")!
  const _component_ArticleHandle = _resolveComponent("ArticleHandle")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Btn = _resolveComponent("Btn")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.integrationEnabled && !_ctx.firstLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("integrations.classroom.introduction")), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", null, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['exams', 'material', 'roster', 'exam_participations'], (feature) => {
                return _createElementVNode("li", {
                  class: "flex items-start space-x-2 my-2",
                  key: feature
                }, [
                  _hoisted_5,
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("integrations.classroom.feature_" + feature)), 1)
                ])
              }), 64))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_GoogleScopeChecker, {
      class: "flex flex-col items-center mt-4",
      role: 'teacher',
      onScopesOk: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scopesVerified = true))
    }),
    (_ctx.scopesVerified)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_Toggle, {
            labelOnLeft: true,
            modelValue: _ctx.integrationEnabled,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.integrationEnabled) = $event))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("integrations.classroom.enable")), 1)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          (_ctx.integrationEnabled)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.currentCourse.name) + " " + _toDisplayString(_ctx.$t("integrations.classroom.is_paired_with")) + ": ", 1),
                  _createVNode(_component_GoogleClassroomCourseItem, {
                    course: _ctx.twinCourse.data,
                    class: "mt-4"
                  }, null, 8, ["course"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _createVNode(_component_ArticleHandle, {
                    articleId: 'evo_classroom_integration',
                    text: _ctx.$t('integrations.classroom.find_out_features')
                  }, null, 8, ["text"])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      onNo: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDisableIntegrationDialog = false)),
      onYes: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onIntegrationDisable())),
      dismissible: true,
      showDialog: _ctx.showDisableIntegrationDialog,
      warning: true,
      yesText: _ctx.disablingIntegration ? _ctx.$t('misc.wait') : _ctx.$t('misc.disable'),
      noText: _ctx.$t('integrations.classroom.keep_active'),
      disableOk: _ctx.disablingIntegration || !_ctx.disableConfirmCheckSuccess
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("integrations.classroom.disable_title")), 1)
      ]),
      body: _withCtx(() => [
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("integrations.classroom.disable_body")), 1),
        _createElementVNode("ul", null, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['exams', 'material', 'roster', 'exam_participations'], (feature) => {
            return _createElementVNode("li", {
              class: "list-disc list-inside",
              key: feature
            }, _toDisplayString(_ctx.$t("integrations.classroom.feature_" + feature)), 1)
          }), 64))
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("h5", null, _toDisplayString(_ctx.$t("misc.warning")), 1)
            ]),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t("integrations.classroom.disable_warning")), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("integrations.classroom.type_course_name_to_disable_integration")) + " “", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.currentCourse.name), 1),
            _createTextVNode("”: ")
          ]),
          _createVNode(_component_TextInput, {
            modelValue: _ctx.disableConfirmText,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.disableConfirmText) = $event))
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["showDialog", "yesText", "noText", "disableOk"]),
    _createVNode(_component_Dialog, {
      showDialog: _ctx.showBlockingDialog,
      onYes: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resolveBlockingDialog(!(_ctx.classroomCourses.length === 0)))),
      onNo: _cache[7] || (_cache[7] = ($event: any) => (_ctx.resolveBlockingDialog(false))),
      yesText: 
				_ctx.creatingCourseTwin
					? _ctx.$t('misc.wait')
					: _ctx.classroomCourses.length === 0
					? _ctx.$t('dialog.default_ok_text')
					: _ctx.$t('integrations.classroom.pair_course')
			,
      noText: _ctx.$t('dialog.default_cancel_text'),
      confirmOnly: _ctx.classroomCourses.length === 0,
      disableOk: 
				(_ctx.classroomCourses.length > 0 && _ctx.selectedClassroomCourseId === null) ||
				_ctx.creatingCourseTwin
			,
      large: true
    }, {
      title: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("integrations.classroom.pair_a_classroom_course")), 1)
      ]),
      body: _withCtx(() => [
        (_ctx.fetchingClassroomCourses)
          ? (_openBlock(), _createBlock(_component_Spinner, {
              key: 0,
              class: "mt-4",
              size: 'xl'
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_18, [
              (_ctx.errorWhileFetchingClassroomCourses)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("misc.an_error_occurred")), 1),
                    _createVNode(_component_Btn, {
                      class: "",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.fetchClassroomCourses()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("misc.try_again")), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    (_ctx.classroomCourses.length > 0)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.$t("integrations.classroom.select_course_to_pair")) + " " + _toDisplayString(_ctx.currentCourse.name) + ". ", 1))
                      : (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.$t("integrations.classroom.you_dont_teach_any_courses")), 1)),
                    _createElementVNode("div", _hoisted_25, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classroomCourses, (course) => {
                        return (_openBlock(), _createBlock(_component_GoogleClassroomCourseItem, {
                          tabindex: "0",
                          selected: _ctx.selectedClassroomCourseId === course.id,
                          onCourseSelected: ($event: any) => (_ctx.selectedClassroomCourseId = course.id),
                          course: course,
                          key: course.id,
                          selectable: true,
                          hoverable: true
                        }, null, 8, ["selected", "onCourseSelected", "course"]))
                      }), 128))
                    ])
                  ]))
            ]))
      ]),
      _: 1
    }, 8, ["showDialog", "yesText", "noText", "confirmOnly", "disableOk"])
  ]))
}